<template>
    <div class="modal-content position-relative">
        <div class="position-absolute d-flex justify-content-end" style="right: 0">
            <button type="button" class="btn p-3" data-dismiss="modal"><i class="las la-times" style="font-size: 1.6rem"></i></button>
        </div>

        <div class="modal-header justify-content-center border-0">
            <h5 class="modal-title ml-3">{{ title }} <span>({{store.currentPage+1}}/3)</span></h5>
        </div>
        <div class="modal-body text-center position-relative d-flex flex-column align-items-center">
            <slot></slot>
        </div>
        <div class="modal-footer justify-content-center border-0">
            <button type="button" class="btn btn-secondary" @click="nextPage">
                <template v-if="!lastPage">
                    {{ $trans('storefront::image_editor.next') }}
                </template>
                <template v-else>
                    {{ $trans('storefront::image_editor.tutorial_close') }}
                </template>
            </button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.modal-body {
    min-height: 150px;
}
.tap-circle {
    position: absolute;
    top: -3px;
    left: 5px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: rgba(35, 187, 248, 0.69);
    opacity: 0;
}

</style>

<script>

import {useMobileTutorialStore} from "../js/store";

export default {
    props: ['title', 'lastPage'],
    setup() {
        const store = useMobileTutorialStore();

        return {
            store: store,
        }
    },
    methods: {
        nextPage() {
            this.$emit('nextPage');
        },
    }
}
</script>
